import React from 'react'
import PropTypes from 'prop-types'

// Components
import AnimateSplitText from '../animation/AnimateSplitText'

// Vars
import { Label } from '../../styles/vars/textStyles.style'

// Styles
import { ImageLabel } from './index.style'

// SVGs
import Pin from '../svgs/Pin'

const ImageLabelComponent = ({ id, imageLabel, delay }) => {
  return (
    <ImageLabel>
      <Pin />
      <Label>
        <AnimateSplitText id={id} delay={delay}>
          {imageLabel}
        </AnimateSplitText>
      </Label>
    </ImageLabel>
  )
}

ImageLabelComponent.propTypes = {
  id: PropTypes.string.isRequired,
  imageLabel: PropTypes.string,
  delay: PropTypes.number,
}

export default ImageLabelComponent
